const bookingMatchNames = {
  Unknown: 'Unknown',
  TrackingCode: 'Tracking code',
  PhoneNumber: 'Phone number',
  Email: 'Email',
  ExactBookingGuestName: 'Exact guest name',
  LastNameZip: 'Lname + ZIP'
}

export default bookingMatchNames
